import * as yup from 'yup';

const partnerFormSchema = yup.object().shape({
  name: yup
    .string()
    .min(3, 'Name must be at least 3 characters')
    .max(100, 'Name must be at most 100 characters')
    .required('Partner name is required'),
  companyNumber: yup
    .string()
    .min(1, 'Company number must be at least 1 character')
    .max(20)
    .required('Company number is required'),
  countryCode: yup.string().optional(),
  addressLine1: yup.string().max(50).optional(),
  addressLine2: yup.string().max(50).optional(),
  addressLine3: yup.string().max(50).optional(),
  city: yup.string().max(50).optional(),
  postCode: yup.string().max(9).optional(),
  addressCountryCode: yup.string().optional(),
});

export default partnerFormSchema;
